import { useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { PiFileArrowDownDuotone, PiFileArrowUpDuotone, PiTreeDuotone } from 'react-icons/pi';
// @ts-ignore
import JsonView from 'react18-json-view';

import { GraphActionType, migrateGraph } from '@spazious/dollhouse-shallow-graph';
import { useHistory, useStore } from '@spazious/dollhouse-store';
import { Flex, IconButton, Stack } from '@spazious/dollhouse-uikit';
import { downloadUrl } from '@spazious/dollhouse-utils';
import { useEventCallback } from '@spazious/react-hooks';

import 'react18-json-view/src/style.css';

export enum Mode {
  Shallow = 0,
  Deep = 1,
}

export interface ShallowGraphViewerProps {}
export const ShallowGraphViewer: React.FC<ShallowGraphViewerProps> = () => {
  const [mode, setMode] = useState<Mode>(Mode.Shallow);
  const { graph } = useStore();
  const history = useHistory();

  const handleDownloadClick = useEventCallback(() => {
    const blob = new Blob([JSON.stringify(graph.shallow, null, 4)], {
      type: 'application/json',
    });
    const url = URL.createObjectURL(blob);
    downloadUrl(url, `${new Date().getTime()}-shallow-graph.json`);
  });

  const onDrop = useEventCallback((acceptedFiles: File[]) => {
    const file = acceptedFiles[0];
    const reader = new FileReader();
    reader.onload = () => {
      const data = JSON.parse(reader.result as string);
      history.reset([
        {
          type: GraphActionType.Init,
          payload: migrateGraph(data),
        },
      ]);
    };
    reader.readAsText(file);
  });

  const { getRootProps, getInputProps, open } = useDropzone({
    noClick: true,
    accept: {
      'application/json': ['.json'],
    },
    multiple: false,
    onDrop,
  });

  return (
    <Flex column position="relative" {...getRootProps()}>
      <Flex column position="sticky" top="0">
        <Flex
          column
          style={{
            position: 'absolute',
            right: '0',
          }}
        >
          <Stack column>
            <IconButton onClick={open}>
              <PiFileArrowUpDuotone />
            </IconButton>
            <input {...getInputProps()} />
            <IconButton onClick={handleDownloadClick}>
              <PiFileArrowDownDuotone />
            </IconButton>
            <IconButton
              onClick={() => {
                setMode(mode === Mode.Shallow ? Mode.Deep : Mode.Shallow);
              }}
            >
              <PiTreeDuotone />
            </IconButton>
          </Stack>
        </Flex>
      </Flex>
      <Flex column fontSize="10px" height="100%" overflow="auto">
        <JsonView src={mode === Mode.Shallow ? graph.shallow : {}} />
      </Flex>
    </Flex>
  );
};
